import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';

import fields from '../../lib/fields';

import ImageScroller from '../../components/imagescroller';
import GuiInfoBox from '../../components/gui/infoBox';
import PaymentVipps from '../../components/payment/vipps';
import PaymentBank from '../../components/payment/bank';
import PaymentPaypal from '../../components/payment/paypal';

import localUtil from '../../lib/util';

@withText(props => ({
    amountText: <Text id='race-class.signup.amount-title'>Amount to pay</Text>,
}))
@observer
class RaceClassContestantPaySignupFee extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sessionid: new Date().getTime(),
            paymentMethods: [],
        };
        this.mainContainer = null;
    }

    loadAll = async (props = this.props) => {
        const { raceClassContestantStore, raceStore } = this.props.stores;
        const { raceClassContestant } = raceClassContestantStore;
        if (raceClassContestant.vippsSignupfeeReference) {
            this.checkVippsPayment();
        }

        const paymentMethods = [];
        const { race, customers } = raceStore;
        const currentCustomer = customers?.find(c => c.id === race.customer);
        const { vippsName, bankAccountNumber } = race;
        const { vippsTermsOfSale } = currentCustomer || {};
        if (vippsName) {
            if (!raceClassContestant.paymentMethod) {
                await raceClassContestantStore.saveField(raceClassContestant.id, 'paymentMethod', 'vipps', true);
            }
            paymentMethods.push('vipps');
        }
        if (bankAccountNumber) {
            if (!raceClassContestant.paymentMethod) {
                await raceClassContestantStore.saveField(raceClassContestant.id, 'paymentMethod', 'vipps', true);
            }
            paymentMethods.push('bank');
        }
        this.setState({ paymentMethods });
    }

    choosePaymentMethod = async (e) => {
        const { method } = e.target.closest('button').dataset;
        const { raceClassContestantStore } = this.props.stores;
        const { raceClassContestant } = raceClassContestantStore;
        await raceClassContestantStore.saveField(raceClassContestant.id, 'paymentMethod', method, true);
    }

    checkVippsPayment = async () => {
        const { raceClassContestantStore } = this.props.stores;
        const { raceClassContestant } = raceClassContestantStore;
        if (raceClassContestant.paidSignupfee || !raceClassContestant.vippsSignupfeeReference) {
            return;
        }
        const hasPaid = await raceClassContestantStore.checkSignupFeeByVipps(raceClassContestant.uuidv4);
        setTimeout(() => {
            this.checkVippsPayment();
        }, 2000);
    }

    payment = () => {
        const { raceClassContestantStore } = this.props.stores;
        const { raceClassContestant } = raceClassContestantStore;
        const { paymentMethods = [] } = this.state;
        let paymentMethod = raceClassContestant.paymentMethod || paymentMethods[0];
        if (!paymentMethods.includes(paymentMethod)) {
            paymentMethod = paymentMethods[0];
        }
        switch (paymentMethod) {
            case 'vipps':
                return <PaymentVipps stores={this.props.stores} type={'fee'} />;
                break;
            case 'bank':
                return <PaymentBank stores={this.props.stores} type={'fee'} />;
                break;
            case 'paypal':
                return <PaymentPaypal stores={this.props.stores} type={'fee'} />;
                break;
            default:
                return <PaymentVipps stores={this.props.stores} type={'fee'} amount={raceClassContestant.signupfeeAmount} />;
                break;
        }
    }

    receipt = () => {
        const { raceClassContestantStore } = this.props.stores;
        const { raceClassContestant } = raceClassContestantStore;
        const { paymentMethods = [] } = this.state;
        let paymentMethod = raceClassContestant.paymentMethod || paymentMethods[0];
        if (!paymentMethods.includes(paymentMethod)) {
            paymentMethod = paymentMethods[0];
        }
        switch (paymentMethod) {
            case 'vipps':
                return <PaymentVipps stores={this.props.stores} type={'fee'} />;
                break;
            case 'bank':
                return <PaymentBank stores={this.props.stores} type={'fee'} />;
                break;
            case 'paypal':
                return <PaymentPaypal stores={this.props.stores} type={'fee'} />;
                break;
            default:
                return <PaymentVipps stores={this.props.stores} type={'fee'} />;
                break;
        }
    }

    componentDidMount() {
        this.loadAll();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.page !== this.props.page || nextProps.artid !== this.props.artid) {
            this.loadAll(nextProps);
        }
    }

    render() {
        const { paymentInProgress, paymentMethods } = this.state;
        const {
            amountText,
        } = this.props;
        const { appState, userStore, raceClassContestantStore, raceStore } = this.props.stores;
        const { user = {}, isAdmin, isTester, isVeterinary, language } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { raceClassContestant } = raceClassContestantStore;

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100 h-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        <Text id='race-class.signupfee.payment'>Race Signup Fee Payment</Text>
                    </div>

                    <div class='w-100 d-flex flex-column'>
                        <div class={`d-flex flex-column mx-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                            {raceClassContestant.paidSignupfee ? <>
                                {this.receipt()}
                            </> : <>
                                {this.payment()}
                            </>}
                        </div>
                    </div>

                    {!raceClassContestant.paidSignupfee && <>
                        <div class='font-weight-lighter px-3 box-header mt-4'>
                            <Text id='race-class.payment-methods'>Payment methods</Text>
                        </div>
                        <div class='w-100 d-flex flex-column'>
                            <div class={`d-flex flex-column mx-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} px-4 py-3`}>
                                <div class='w-100 d-flex flex-row justify-content-center'>
                                    {paymentMethods.map(method => {
                                        return (<>
                                            <button
                                                type='button'
                                                data-method={method}
                                                class={`btn btn-${method === raceClassContestant.paymentMethod ? 'primary' : 'outline-secondary'} rounded-pill me-2 mt-2`}
                                                onClick={this.choosePaymentMethod}
                                            >
                                                {method}
                                            </button>
                                        </>);
                                    })}
                                </div>

                            </div>
                        </div>
                    </>}

                </div>
            </div>
        </>);
    }
}

export default RaceClassContestantPaySignupFee;
